import { render, staticRenderFns } from "./CheckButton.vue?vue&type=template&id=c4d885fa&"
import script from "./CheckButton.vue?vue&type=script&lang=js&"
export * from "./CheckButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckButton.vue?vue&type=style&index=0&id=c4d885fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports